const variables = {
	colors: {
		primary: '#009FE3',
		secondary: '#D65219',
		success: '#3EC97E',
		error: '#F94848',
		warning: '#FFC043',
		info: '#276EF1'
	}
};

export default variables;
